var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-wap-title"},[(_vm.back_returnUrl)?_c('div',{staticClass:"return",on:{"click":_vm.doReturn}},[_c('span',{staticClass:"icontemp zuojiantou-"}),_vm._v(" 返回 ")]):_vm._e(),_c('div',{staticClass:"wap-title",style:({
      color: _vm.extraItem.extras('titlefont.color'),
      fontSize: _vm.extraItem.extras('titlefont.size')
        ? _vm.pxOrVw(_vm.extraItem.extras('titlefont.size'))
        : '-1px',
      fontWeight:
        _vm.extraItem.extras('titlefont.weight') == 'default'
          ? '500'
          : _vm.extraItem.extras('titlefont.weight')
    }),attrs:{"title":_vm.title}},[_vm._v(" "+_vm._s(_vm.title)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }